
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/orders/order-status",
      function () {
        return require("private-next-pages/orders/order-status.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/orders/order-status"])
      });
    }
  